import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnInit } from '@angular/core';
import { Country } from 'app/shared/shared.types';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { UtilService } from 'app/shared/util.service';
import { take } from 'rxjs';

@Component({
    selector: 'app-country-selector',
    templateUrl: './country-selector.component.html',
    styleUrls: ['./country-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CountrySelectorComponent),
            multi: true
        }
    ],
})

//TODO Keyboard navigation
export class CountrySelectorComponent implements OnInit, ControlValueAccessor {
    @Input() emptyChipLabel: string;

    selectedCountries: Country[];
    availableCountries: Country[];
    filteredCountries: Country[];
    searchForm: FormGroup;
    disabled: boolean;

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _formBuilder: FormBuilder,
        public utilService: UtilService,
    ) {
    }

    ngOnInit(): void {
        this.utilService.countries$.pipe(take(1)).subscribe(value => this.availableCountries = value);

        this.searchForm = this._formBuilder.group({
            countries: [''],
        });

        this.searchForm.get('countries').valueChanges.subscribe(filterValue => {
            this.updateFilteredCountries();
        });
        this.updateFilteredCountries();
    }

    onChange = (_: any) => {
    };

    onTouched = () => {
    };

    setCountries(countries: Country[], updateFromModel?: boolean) {
        this.selectedCountries = countries;

        if (!updateFromModel) {
            this.onChange(countries);
        }
        this._changeDetectorRef.markForCheck();
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(value: Country[]): void {
        this.setCountries(value, true);
    }

    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }

    onContainerClick() {
        this.onTouched();
    }

    getCountryName(iso: string) {
        return this.availableCountries.find(country => country.alpha2 === iso).name;
    }

    addCountry(value: Country) {
        this.searchForm.reset();
        this.setCountries(this.selectedCountries.concat(value));
        this.updateFilteredCountries();
    }

    removeCountry(value: Country) {
        this.setCountries(this.selectedCountries.filter(iso => iso !== value));
        this.updateFilteredCountries();
    }

    updateFilteredCountries() {
        let filterValue = this.searchForm.get('countries').value?.toLowerCase().trim();
        this.filteredCountries = this.availableCountries.filter(country => !filterValue || country.name.toLowerCase().startsWith(filterValue) || country.alpha2.toLowerCase() === filterValue);
        this.filteredCountries = this.filteredCountries.filter(country => !this.selectedCountries?.find(selectedCountry => selectedCountry.uuid === country.uuid));
    }

    stopPropagation($event: MouseEvent) {
        $event.preventDefault();
        $event.stopPropagation();
    }

    trackByFn(index: number, item: any): any {
        return item.id || index;
    }
}
